<script lang="ts" setup>
import { ref } from "vue"
import { ButtonSize, TuIconButton, TuPopover, usePopover } from "@tinyurldev/tu-ui-vue"

import useTranslation from "@Composables/useTranslation"

//
// Setup
const { __ } = useTranslation()

//
// Emit
const emit = defineEmits<{
  (e: "deactivate"): void
}>()

//
// Data
const isPopoverVisible = ref(false)
const { referenceRef, popoverRef } = usePopover(isPopoverVisible, { placement: "bottom-end" })

//
// Methods
function onToggle(): void {
  isPopoverVisible.value = !isPopoverVisible.value
}

function onDeactivateClick(): void {
  isPopoverVisible.value = false
  emit("deactivate")
}
</script>

<template>
  <div class="org-user-action-dropdown">
    <TuIconButton
      ref="referenceRef"
      class="_actions"
      :aria-label="__('organization_users_settings.user_actions')"
      icon-class="fa-solid fa-gear"
      is-outlined
      :size="ButtonSize.MEDIUM"
      @click="onToggle"
    />

    <TuPopover
      v-show="isPopoverVisible"
      ref="popoverRef"
    >
      <div class="org-user-action-dropdown__menu _actions_menu">
        <button
          class="org-user-action-dropdown__menu-item org-user-action-dropdown__menu-item--deactivate _deactivate"
          type="button"
          @click="onDeactivateClick"
        >
          {{ __('organization_users_settings.deactivate') }}
        </button>
      </div>
    </TuPopover>
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/colors.scss" as color;
@use "@tinyurldev/tu-ui-vue/scss/settings/border.scss" as border;
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;
@use "@tinyurldev/tu-ui-vue/scss/settings/typography.scss" as typography;

.org-user-action-dropdown {
  &__menu {
    display: flex;
    flex-direction: column;
    padding: spacing.$xs-5 0;

    background-color: color.$background-secondary;
    border-radius: border.$medium-radius;
  }

  &__menu-item {
    width: 100%;
    padding: spacing.$xxxxs spacing.$xxxs;

    font-size: typography.$xs-font-size;
    font-weight: typography.$font-weight-medium;
    line-height: typography.$xs-line-height;
    text-align: left;
    color: color.$text;

    background: none;
    border: none;
    cursor: pointer;

    &:hover {
      background-color: color.$background-primary;
    }

    &--deactivate {
      color: color.$alert;
    }
  }
}
</style>
